// source: proto/entity/hub.proto
/**
 * @fileoverview
 * @enhanceable
 * @suppress {missingRequire} reports error on implicit type usages.
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!
/* eslint-disable */
// @ts-nocheck

var jspb = require('google-protobuf');
var goog = jspb;
var global = (function() {
  if (this) { return this; }
  if (typeof window !== 'undefined') { return window; }
  if (typeof global !== 'undefined') { return global; }
  if (typeof self !== 'undefined') { return self; }
  return Function('return this')();
}.call(null));

var proto_common_crudFields_pb = require('../../proto/common/crudFields_pb.js');
goog.object.extend(proto, proto_common_crudFields_pb);
var proto_common_objectID_pb = require('../../proto/common/objectID_pb.js');
goog.object.extend(proto, proto_common_objectID_pb);
var proto_common_value_pb = require('../../proto/common/value_pb.js');
goog.object.extend(proto, proto_common_value_pb);
goog.exportSymbol('proto.entity.FixedDimension', null, global);
goog.exportSymbol('proto.entity.Hub', null, global);
goog.exportSymbol('proto.entity.HubDetails', null, global);
goog.exportSymbol('proto.entity.HubDetails.TypeCase', null, global);
goog.exportSymbol('proto.entity.HubFromYAML', null, global);
goog.exportSymbol('proto.entity.HubFromYAML.InheritBehavior', null, global);
goog.exportSymbol('proto.entity.HubFromYAML.InheritBehavior.Option', null, global);
goog.exportSymbol('proto.entity.HubSelector', null, global);
goog.exportSymbol('proto.entity.HubSelector.SelectorCase', null, global);
goog.exportSymbol('proto.entity.ProductHub', null, global);
goog.exportSymbol('proto.entity.SessionHub', null, global);
goog.exportSymbol('proto.entity.TreeNodeHub', null, global);
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.entity.HubSelector = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, proto.entity.HubSelector.oneofGroups_);
};
goog.inherits(proto.entity.HubSelector, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.entity.HubSelector.displayName = 'proto.entity.HubSelector';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.entity.HubFromYAML = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.entity.HubFromYAML, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.entity.HubFromYAML.displayName = 'proto.entity.HubFromYAML';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.entity.HubFromYAML.InheritBehavior = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.entity.HubFromYAML.InheritBehavior, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.entity.HubFromYAML.InheritBehavior.displayName = 'proto.entity.HubFromYAML.InheritBehavior';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.entity.Hub = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.entity.Hub, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.entity.Hub.displayName = 'proto.entity.Hub';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.entity.HubDetails = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, proto.entity.HubDetails.oneofGroups_);
};
goog.inherits(proto.entity.HubDetails, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.entity.HubDetails.displayName = 'proto.entity.HubDetails';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.entity.SessionHub = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.entity.SessionHub.repeatedFields_, null);
};
goog.inherits(proto.entity.SessionHub, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.entity.SessionHub.displayName = 'proto.entity.SessionHub';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.entity.ProductHub = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.entity.ProductHub.repeatedFields_, null);
};
goog.inherits(proto.entity.ProductHub, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.entity.ProductHub.displayName = 'proto.entity.ProductHub';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.entity.TreeNodeHub = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.entity.TreeNodeHub.repeatedFields_, null);
};
goog.inherits(proto.entity.TreeNodeHub, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.entity.TreeNodeHub.displayName = 'proto.entity.TreeNodeHub';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.entity.FixedDimension = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.entity.FixedDimension, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.entity.FixedDimension.displayName = 'proto.entity.FixedDimension';
}

/**
 * Oneof group definitions for this message. Each group defines the field
 * numbers belonging to that group. When of these fields' value is set, all
 * other fields in the group are cleared. During deserialization, if multiple
 * fields are encountered for a group, only the last value seen will be kept.
 * @private {!Array<!Array<number>>}
 * @const
 */
proto.entity.HubSelector.oneofGroups_ = [[1,2]];

/**
 * @enum {number}
 */
proto.entity.HubSelector.SelectorCase = {
  SELECTOR_NOT_SET: 0,
  HUB_ID: 1,
  HUB_ALIAS: 2
};

/**
 * @return {proto.entity.HubSelector.SelectorCase}
 */
proto.entity.HubSelector.prototype.getSelectorCase = function() {
  return /** @type {proto.entity.HubSelector.SelectorCase} */(jspb.Message.computeOneofCase(this, proto.entity.HubSelector.oneofGroups_[0]));
};



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.entity.HubSelector.prototype.toObject = function(opt_includeInstance) {
  return proto.entity.HubSelector.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.entity.HubSelector} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.entity.HubSelector.toObject = function(includeInstance, msg) {
  var f, obj = {
    hubId: (f = msg.getHubId()) && proto_common_objectID_pb.ObjectID.toObject(includeInstance, f),
    hubAlias: jspb.Message.getFieldWithDefault(msg, 2, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.entity.HubSelector}
 */
proto.entity.HubSelector.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.entity.HubSelector;
  return proto.entity.HubSelector.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.entity.HubSelector} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.entity.HubSelector}
 */
proto.entity.HubSelector.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto_common_objectID_pb.ObjectID;
      reader.readMessage(value,proto_common_objectID_pb.ObjectID.deserializeBinaryFromReader);
      msg.setHubId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setHubAlias(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.entity.HubSelector.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.entity.HubSelector.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.entity.HubSelector} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.entity.HubSelector.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getHubId();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto_common_objectID_pb.ObjectID.serializeBinaryToWriter
    );
  }
  f = /** @type {string} */ (jspb.Message.getField(message, 2));
  if (f != null) {
    writer.writeString(
      2,
      f
    );
  }
};


/**
 * optional common.ObjectID hub_id = 1;
 * @return {?proto.common.ObjectID}
 */
proto.entity.HubSelector.prototype.getHubId = function() {
  return /** @type{?proto.common.ObjectID} */ (
    jspb.Message.getWrapperField(this, proto_common_objectID_pb.ObjectID, 1));
};


/**
 * @param {?proto.common.ObjectID|undefined} value
 * @return {!proto.entity.HubSelector} returns this
*/
proto.entity.HubSelector.prototype.setHubId = function(value) {
  return jspb.Message.setOneofWrapperField(this, 1, proto.entity.HubSelector.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.entity.HubSelector} returns this
 */
proto.entity.HubSelector.prototype.clearHubId = function() {
  return this.setHubId(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.entity.HubSelector.prototype.hasHubId = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional string hub_alias = 2;
 * @return {string}
 */
proto.entity.HubSelector.prototype.getHubAlias = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.entity.HubSelector} returns this
 */
proto.entity.HubSelector.prototype.setHubAlias = function(value) {
  return jspb.Message.setOneofField(this, 2, proto.entity.HubSelector.oneofGroups_[0], value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.entity.HubSelector} returns this
 */
proto.entity.HubSelector.prototype.clearHubAlias = function() {
  return jspb.Message.setOneofField(this, 2, proto.entity.HubSelector.oneofGroups_[0], undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.entity.HubSelector.prototype.hasHubAlias = function() {
  return jspb.Message.getField(this, 2) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.entity.HubFromYAML.prototype.toObject = function(opt_includeInstance) {
  return proto.entity.HubFromYAML.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.entity.HubFromYAML} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.entity.HubFromYAML.toObject = function(includeInstance, msg) {
  var f, obj = {
    siteAlias: jspb.Message.getFieldWithDefault(msg, 1, ""),
    hubAlias: jspb.Message.getFieldWithDefault(msg, 2, ""),
    displayName: jspb.Message.getFieldWithDefault(msg, 3, ""),
    hubDetails: (f = msg.getHubDetails()) && proto.entity.HubDetails.toObject(includeInstance, f),
    inheritBehavior: jspb.Message.getFieldWithDefault(msg, 5, 0),
    inheritFromHubAlias: jspb.Message.getFieldWithDefault(msg, 6, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.entity.HubFromYAML}
 */
proto.entity.HubFromYAML.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.entity.HubFromYAML;
  return proto.entity.HubFromYAML.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.entity.HubFromYAML} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.entity.HubFromYAML}
 */
proto.entity.HubFromYAML.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setSiteAlias(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setHubAlias(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setDisplayName(value);
      break;
    case 4:
      var value = new proto.entity.HubDetails;
      reader.readMessage(value,proto.entity.HubDetails.deserializeBinaryFromReader);
      msg.setHubDetails(value);
      break;
    case 5:
      var value = /** @type {!proto.entity.HubFromYAML.InheritBehavior.Option} */ (reader.readEnum());
      msg.setInheritBehavior(value);
      break;
    case 6:
      var value = /** @type {string} */ (reader.readString());
      msg.setInheritFromHubAlias(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.entity.HubFromYAML.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.entity.HubFromYAML.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.entity.HubFromYAML} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.entity.HubFromYAML.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getSiteAlias();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getHubAlias();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getDisplayName();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getHubDetails();
  if (f != null) {
    writer.writeMessage(
      4,
      f,
      proto.entity.HubDetails.serializeBinaryToWriter
    );
  }
  f = message.getInheritBehavior();
  if (f !== 0.0) {
    writer.writeEnum(
      5,
      f
    );
  }
  f = message.getInheritFromHubAlias();
  if (f.length > 0) {
    writer.writeString(
      6,
      f
    );
  }
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.entity.HubFromYAML.InheritBehavior.prototype.toObject = function(opt_includeInstance) {
  return proto.entity.HubFromYAML.InheritBehavior.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.entity.HubFromYAML.InheritBehavior} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.entity.HubFromYAML.InheritBehavior.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.entity.HubFromYAML.InheritBehavior}
 */
proto.entity.HubFromYAML.InheritBehavior.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.entity.HubFromYAML.InheritBehavior;
  return proto.entity.HubFromYAML.InheritBehavior.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.entity.HubFromYAML.InheritBehavior} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.entity.HubFromYAML.InheritBehavior}
 */
proto.entity.HubFromYAML.InheritBehavior.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.entity.HubFromYAML.InheritBehavior.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.entity.HubFromYAML.InheritBehavior.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.entity.HubFromYAML.InheritBehavior} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.entity.HubFromYAML.InheritBehavior.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};


/**
 * @enum {number}
 */
proto.entity.HubFromYAML.InheritBehavior.Option = {
  ADD: 0,
  REPLACE: 1,
  HIDE: 2,
  MODIFY: 3
};

/**
 * optional string site_alias = 1;
 * @return {string}
 */
proto.entity.HubFromYAML.prototype.getSiteAlias = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.entity.HubFromYAML} returns this
 */
proto.entity.HubFromYAML.prototype.setSiteAlias = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string hub_alias = 2;
 * @return {string}
 */
proto.entity.HubFromYAML.prototype.getHubAlias = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.entity.HubFromYAML} returns this
 */
proto.entity.HubFromYAML.prototype.setHubAlias = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string display_name = 3;
 * @return {string}
 */
proto.entity.HubFromYAML.prototype.getDisplayName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.entity.HubFromYAML} returns this
 */
proto.entity.HubFromYAML.prototype.setDisplayName = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional HubDetails hub_details = 4;
 * @return {?proto.entity.HubDetails}
 */
proto.entity.HubFromYAML.prototype.getHubDetails = function() {
  return /** @type{?proto.entity.HubDetails} */ (
    jspb.Message.getWrapperField(this, proto.entity.HubDetails, 4));
};


/**
 * @param {?proto.entity.HubDetails|undefined} value
 * @return {!proto.entity.HubFromYAML} returns this
*/
proto.entity.HubFromYAML.prototype.setHubDetails = function(value) {
  return jspb.Message.setWrapperField(this, 4, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.entity.HubFromYAML} returns this
 */
proto.entity.HubFromYAML.prototype.clearHubDetails = function() {
  return this.setHubDetails(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.entity.HubFromYAML.prototype.hasHubDetails = function() {
  return jspb.Message.getField(this, 4) != null;
};


/**
 * optional InheritBehavior.Option inherit_behavior = 5;
 * @return {!proto.entity.HubFromYAML.InheritBehavior.Option}
 */
proto.entity.HubFromYAML.prototype.getInheritBehavior = function() {
  return /** @type {!proto.entity.HubFromYAML.InheritBehavior.Option} */ (jspb.Message.getFieldWithDefault(this, 5, 0));
};


/**
 * @param {!proto.entity.HubFromYAML.InheritBehavior.Option} value
 * @return {!proto.entity.HubFromYAML} returns this
 */
proto.entity.HubFromYAML.prototype.setInheritBehavior = function(value) {
  return jspb.Message.setProto3EnumField(this, 5, value);
};


/**
 * optional string inherit_from_hub_alias = 6;
 * @return {string}
 */
proto.entity.HubFromYAML.prototype.getInheritFromHubAlias = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 6, ""));
};


/**
 * @param {string} value
 * @return {!proto.entity.HubFromYAML} returns this
 */
proto.entity.HubFromYAML.prototype.setInheritFromHubAlias = function(value) {
  return jspb.Message.setProto3StringField(this, 6, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.entity.Hub.prototype.toObject = function(opt_includeInstance) {
  return proto.entity.Hub.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.entity.Hub} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.entity.Hub.toObject = function(includeInstance, msg) {
  var f, obj = {
    siteId: (f = msg.getSiteId()) && proto_common_objectID_pb.ObjectID.toObject(includeInstance, f),
    hubId: (f = msg.getHubId()) && proto_common_objectID_pb.ObjectID.toObject(includeInstance, f),
    hubAlias: jspb.Message.getFieldWithDefault(msg, 3, ""),
    displayName: jspb.Message.getFieldWithDefault(msg, 4, ""),
    hubDetails: (f = msg.getHubDetails()) && proto.entity.HubDetails.toObject(includeInstance, f),
    crudFields: (f = msg.getCrudFields()) && proto_common_crudFields_pb.CRUDFields.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.entity.Hub}
 */
proto.entity.Hub.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.entity.Hub;
  return proto.entity.Hub.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.entity.Hub} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.entity.Hub}
 */
proto.entity.Hub.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto_common_objectID_pb.ObjectID;
      reader.readMessage(value,proto_common_objectID_pb.ObjectID.deserializeBinaryFromReader);
      msg.setSiteId(value);
      break;
    case 2:
      var value = new proto_common_objectID_pb.ObjectID;
      reader.readMessage(value,proto_common_objectID_pb.ObjectID.deserializeBinaryFromReader);
      msg.setHubId(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setHubAlias(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setDisplayName(value);
      break;
    case 5:
      var value = new proto.entity.HubDetails;
      reader.readMessage(value,proto.entity.HubDetails.deserializeBinaryFromReader);
      msg.setHubDetails(value);
      break;
    case 6:
      var value = new proto_common_crudFields_pb.CRUDFields;
      reader.readMessage(value,proto_common_crudFields_pb.CRUDFields.deserializeBinaryFromReader);
      msg.setCrudFields(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.entity.Hub.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.entity.Hub.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.entity.Hub} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.entity.Hub.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getSiteId();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto_common_objectID_pb.ObjectID.serializeBinaryToWriter
    );
  }
  f = message.getHubId();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      proto_common_objectID_pb.ObjectID.serializeBinaryToWriter
    );
  }
  f = message.getHubAlias();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getDisplayName();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getHubDetails();
  if (f != null) {
    writer.writeMessage(
      5,
      f,
      proto.entity.HubDetails.serializeBinaryToWriter
    );
  }
  f = message.getCrudFields();
  if (f != null) {
    writer.writeMessage(
      6,
      f,
      proto_common_crudFields_pb.CRUDFields.serializeBinaryToWriter
    );
  }
};


/**
 * optional common.ObjectID site_id = 1;
 * @return {?proto.common.ObjectID}
 */
proto.entity.Hub.prototype.getSiteId = function() {
  return /** @type{?proto.common.ObjectID} */ (
    jspb.Message.getWrapperField(this, proto_common_objectID_pb.ObjectID, 1));
};


/**
 * @param {?proto.common.ObjectID|undefined} value
 * @return {!proto.entity.Hub} returns this
*/
proto.entity.Hub.prototype.setSiteId = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.entity.Hub} returns this
 */
proto.entity.Hub.prototype.clearSiteId = function() {
  return this.setSiteId(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.entity.Hub.prototype.hasSiteId = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional common.ObjectID hub_id = 2;
 * @return {?proto.common.ObjectID}
 */
proto.entity.Hub.prototype.getHubId = function() {
  return /** @type{?proto.common.ObjectID} */ (
    jspb.Message.getWrapperField(this, proto_common_objectID_pb.ObjectID, 2));
};


/**
 * @param {?proto.common.ObjectID|undefined} value
 * @return {!proto.entity.Hub} returns this
*/
proto.entity.Hub.prototype.setHubId = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.entity.Hub} returns this
 */
proto.entity.Hub.prototype.clearHubId = function() {
  return this.setHubId(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.entity.Hub.prototype.hasHubId = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional string hub_alias = 3;
 * @return {string}
 */
proto.entity.Hub.prototype.getHubAlias = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.entity.Hub} returns this
 */
proto.entity.Hub.prototype.setHubAlias = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional string display_name = 4;
 * @return {string}
 */
proto.entity.Hub.prototype.getDisplayName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.entity.Hub} returns this
 */
proto.entity.Hub.prototype.setDisplayName = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional HubDetails hub_details = 5;
 * @return {?proto.entity.HubDetails}
 */
proto.entity.Hub.prototype.getHubDetails = function() {
  return /** @type{?proto.entity.HubDetails} */ (
    jspb.Message.getWrapperField(this, proto.entity.HubDetails, 5));
};


/**
 * @param {?proto.entity.HubDetails|undefined} value
 * @return {!proto.entity.Hub} returns this
*/
proto.entity.Hub.prototype.setHubDetails = function(value) {
  return jspb.Message.setWrapperField(this, 5, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.entity.Hub} returns this
 */
proto.entity.Hub.prototype.clearHubDetails = function() {
  return this.setHubDetails(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.entity.Hub.prototype.hasHubDetails = function() {
  return jspb.Message.getField(this, 5) != null;
};


/**
 * optional common.CRUDFields crud_fields = 6;
 * @return {?proto.common.CRUDFields}
 */
proto.entity.Hub.prototype.getCrudFields = function() {
  return /** @type{?proto.common.CRUDFields} */ (
    jspb.Message.getWrapperField(this, proto_common_crudFields_pb.CRUDFields, 6));
};


/**
 * @param {?proto.common.CRUDFields|undefined} value
 * @return {!proto.entity.Hub} returns this
*/
proto.entity.Hub.prototype.setCrudFields = function(value) {
  return jspb.Message.setWrapperField(this, 6, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.entity.Hub} returns this
 */
proto.entity.Hub.prototype.clearCrudFields = function() {
  return this.setCrudFields(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.entity.Hub.prototype.hasCrudFields = function() {
  return jspb.Message.getField(this, 6) != null;
};



/**
 * Oneof group definitions for this message. Each group defines the field
 * numbers belonging to that group. When of these fields' value is set, all
 * other fields in the group are cleared. During deserialization, if multiple
 * fields are encountered for a group, only the last value seen will be kept.
 * @private {!Array<!Array<number>>}
 * @const
 */
proto.entity.HubDetails.oneofGroups_ = [[1,2,3]];

/**
 * @enum {number}
 */
proto.entity.HubDetails.TypeCase = {
  TYPE_NOT_SET: 0,
  SESSION_HUB: 1,
  PRODUCT_HUB: 2,
  TREE_NODE_HUB: 3
};

/**
 * @return {proto.entity.HubDetails.TypeCase}
 */
proto.entity.HubDetails.prototype.getTypeCase = function() {
  return /** @type {proto.entity.HubDetails.TypeCase} */(jspb.Message.computeOneofCase(this, proto.entity.HubDetails.oneofGroups_[0]));
};



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.entity.HubDetails.prototype.toObject = function(opt_includeInstance) {
  return proto.entity.HubDetails.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.entity.HubDetails} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.entity.HubDetails.toObject = function(includeInstance, msg) {
  var f, obj = {
    sessionHub: (f = msg.getSessionHub()) && proto.entity.SessionHub.toObject(includeInstance, f),
    productHub: (f = msg.getProductHub()) && proto.entity.ProductHub.toObject(includeInstance, f),
    treeNodeHub: (f = msg.getTreeNodeHub()) && proto.entity.TreeNodeHub.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.entity.HubDetails}
 */
proto.entity.HubDetails.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.entity.HubDetails;
  return proto.entity.HubDetails.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.entity.HubDetails} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.entity.HubDetails}
 */
proto.entity.HubDetails.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.entity.SessionHub;
      reader.readMessage(value,proto.entity.SessionHub.deserializeBinaryFromReader);
      msg.setSessionHub(value);
      break;
    case 2:
      var value = new proto.entity.ProductHub;
      reader.readMessage(value,proto.entity.ProductHub.deserializeBinaryFromReader);
      msg.setProductHub(value);
      break;
    case 3:
      var value = new proto.entity.TreeNodeHub;
      reader.readMessage(value,proto.entity.TreeNodeHub.deserializeBinaryFromReader);
      msg.setTreeNodeHub(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.entity.HubDetails.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.entity.HubDetails.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.entity.HubDetails} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.entity.HubDetails.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getSessionHub();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.entity.SessionHub.serializeBinaryToWriter
    );
  }
  f = message.getProductHub();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      proto.entity.ProductHub.serializeBinaryToWriter
    );
  }
  f = message.getTreeNodeHub();
  if (f != null) {
    writer.writeMessage(
      3,
      f,
      proto.entity.TreeNodeHub.serializeBinaryToWriter
    );
  }
};


/**
 * optional SessionHub session_hub = 1;
 * @return {?proto.entity.SessionHub}
 */
proto.entity.HubDetails.prototype.getSessionHub = function() {
  return /** @type{?proto.entity.SessionHub} */ (
    jspb.Message.getWrapperField(this, proto.entity.SessionHub, 1));
};


/**
 * @param {?proto.entity.SessionHub|undefined} value
 * @return {!proto.entity.HubDetails} returns this
*/
proto.entity.HubDetails.prototype.setSessionHub = function(value) {
  return jspb.Message.setOneofWrapperField(this, 1, proto.entity.HubDetails.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.entity.HubDetails} returns this
 */
proto.entity.HubDetails.prototype.clearSessionHub = function() {
  return this.setSessionHub(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.entity.HubDetails.prototype.hasSessionHub = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional ProductHub product_hub = 2;
 * @return {?proto.entity.ProductHub}
 */
proto.entity.HubDetails.prototype.getProductHub = function() {
  return /** @type{?proto.entity.ProductHub} */ (
    jspb.Message.getWrapperField(this, proto.entity.ProductHub, 2));
};


/**
 * @param {?proto.entity.ProductHub|undefined} value
 * @return {!proto.entity.HubDetails} returns this
*/
proto.entity.HubDetails.prototype.setProductHub = function(value) {
  return jspb.Message.setOneofWrapperField(this, 2, proto.entity.HubDetails.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.entity.HubDetails} returns this
 */
proto.entity.HubDetails.prototype.clearProductHub = function() {
  return this.setProductHub(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.entity.HubDetails.prototype.hasProductHub = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional TreeNodeHub tree_node_hub = 3;
 * @return {?proto.entity.TreeNodeHub}
 */
proto.entity.HubDetails.prototype.getTreeNodeHub = function() {
  return /** @type{?proto.entity.TreeNodeHub} */ (
    jspb.Message.getWrapperField(this, proto.entity.TreeNodeHub, 3));
};


/**
 * @param {?proto.entity.TreeNodeHub|undefined} value
 * @return {!proto.entity.HubDetails} returns this
*/
proto.entity.HubDetails.prototype.setTreeNodeHub = function(value) {
  return jspb.Message.setOneofWrapperField(this, 3, proto.entity.HubDetails.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.entity.HubDetails} returns this
 */
proto.entity.HubDetails.prototype.clearTreeNodeHub = function() {
  return this.setTreeNodeHub(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.entity.HubDetails.prototype.hasTreeNodeHub = function() {
  return jspb.Message.getField(this, 3) != null;
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.entity.SessionHub.repeatedFields_ = [9,4,7];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.entity.SessionHub.prototype.toObject = function(opt_includeInstance) {
  return proto.entity.SessionHub.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.entity.SessionHub} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.entity.SessionHub.toObject = function(includeInstance, msg) {
  var f, obj = {
    mainDimension: jspb.Message.getFieldWithDefault(msg, 1, ""),
    detailDimension: jspb.Message.getFieldWithDefault(msg, 2, ""),
    individualDimension: jspb.Message.getFieldWithDefault(msg, 3, ""),
    fixedDimensionsList: jspb.Message.toObjectList(msg.getFixedDimensionsList(),
    proto.entity.FixedDimension.toObject, includeInstance),
    dimensionFilterClausesList: jspb.Message.toObjectList(msg.getDimensionFilterClausesList(),
    proto_common_value_pb.ValueFilterClause.toObject, includeInstance),
    highlightedDetailValue: jspb.Message.getFieldWithDefault(msg, 5, ""),
    primaryMetric: jspb.Message.getFieldWithDefault(msg, 6, ""),
    individualMetric: jspb.Message.getFieldWithDefault(msg, 8, ""),
    detailMetricsList: (f = jspb.Message.getRepeatedField(msg, 7)) == null ? undefined : f
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.entity.SessionHub}
 */
proto.entity.SessionHub.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.entity.SessionHub;
  return proto.entity.SessionHub.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.entity.SessionHub} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.entity.SessionHub}
 */
proto.entity.SessionHub.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setMainDimension(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setDetailDimension(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setIndividualDimension(value);
      break;
    case 9:
      var value = new proto.entity.FixedDimension;
      reader.readMessage(value,proto.entity.FixedDimension.deserializeBinaryFromReader);
      msg.addFixedDimensions(value);
      break;
    case 4:
      var value = new proto_common_value_pb.ValueFilterClause;
      reader.readMessage(value,proto_common_value_pb.ValueFilterClause.deserializeBinaryFromReader);
      msg.addDimensionFilterClauses(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setHighlightedDetailValue(value);
      break;
    case 6:
      var value = /** @type {string} */ (reader.readString());
      msg.setPrimaryMetric(value);
      break;
    case 8:
      var value = /** @type {string} */ (reader.readString());
      msg.setIndividualMetric(value);
      break;
    case 7:
      var value = /** @type {string} */ (reader.readString());
      msg.addDetailMetrics(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.entity.SessionHub.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.entity.SessionHub.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.entity.SessionHub} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.entity.SessionHub.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getMainDimension();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getDetailDimension();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getIndividualDimension();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getFixedDimensionsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      9,
      f,
      proto.entity.FixedDimension.serializeBinaryToWriter
    );
  }
  f = message.getDimensionFilterClausesList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      4,
      f,
      proto_common_value_pb.ValueFilterClause.serializeBinaryToWriter
    );
  }
  f = message.getHighlightedDetailValue();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
  f = message.getPrimaryMetric();
  if (f.length > 0) {
    writer.writeString(
      6,
      f
    );
  }
  f = message.getIndividualMetric();
  if (f.length > 0) {
    writer.writeString(
      8,
      f
    );
  }
  f = message.getDetailMetricsList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      7,
      f
    );
  }
};


/**
 * optional string main_dimension = 1;
 * @return {string}
 */
proto.entity.SessionHub.prototype.getMainDimension = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.entity.SessionHub} returns this
 */
proto.entity.SessionHub.prototype.setMainDimension = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string detail_dimension = 2;
 * @return {string}
 */
proto.entity.SessionHub.prototype.getDetailDimension = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.entity.SessionHub} returns this
 */
proto.entity.SessionHub.prototype.setDetailDimension = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string individual_dimension = 3;
 * @return {string}
 */
proto.entity.SessionHub.prototype.getIndividualDimension = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.entity.SessionHub} returns this
 */
proto.entity.SessionHub.prototype.setIndividualDimension = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * repeated FixedDimension fixed_dimensions = 9;
 * @return {!Array<!proto.entity.FixedDimension>}
 */
proto.entity.SessionHub.prototype.getFixedDimensionsList = function() {
  return /** @type{!Array<!proto.entity.FixedDimension>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.entity.FixedDimension, 9));
};


/**
 * @param {!Array<!proto.entity.FixedDimension>} value
 * @return {!proto.entity.SessionHub} returns this
*/
proto.entity.SessionHub.prototype.setFixedDimensionsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 9, value);
};


/**
 * @param {!proto.entity.FixedDimension=} opt_value
 * @param {number=} opt_index
 * @return {!proto.entity.FixedDimension}
 */
proto.entity.SessionHub.prototype.addFixedDimensions = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 9, opt_value, proto.entity.FixedDimension, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.entity.SessionHub} returns this
 */
proto.entity.SessionHub.prototype.clearFixedDimensionsList = function() {
  return this.setFixedDimensionsList([]);
};


/**
 * repeated common.ValueFilterClause dimension_filter_clauses = 4;
 * @return {!Array<!proto.common.ValueFilterClause>}
 */
proto.entity.SessionHub.prototype.getDimensionFilterClausesList = function() {
  return /** @type{!Array<!proto.common.ValueFilterClause>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto_common_value_pb.ValueFilterClause, 4));
};


/**
 * @param {!Array<!proto.common.ValueFilterClause>} value
 * @return {!proto.entity.SessionHub} returns this
*/
proto.entity.SessionHub.prototype.setDimensionFilterClausesList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 4, value);
};


/**
 * @param {!proto.common.ValueFilterClause=} opt_value
 * @param {number=} opt_index
 * @return {!proto.common.ValueFilterClause}
 */
proto.entity.SessionHub.prototype.addDimensionFilterClauses = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 4, opt_value, proto.common.ValueFilterClause, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.entity.SessionHub} returns this
 */
proto.entity.SessionHub.prototype.clearDimensionFilterClausesList = function() {
  return this.setDimensionFilterClausesList([]);
};


/**
 * optional string highlighted_detail_value = 5;
 * @return {string}
 */
proto.entity.SessionHub.prototype.getHighlightedDetailValue = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/**
 * @param {string} value
 * @return {!proto.entity.SessionHub} returns this
 */
proto.entity.SessionHub.prototype.setHighlightedDetailValue = function(value) {
  return jspb.Message.setProto3StringField(this, 5, value);
};


/**
 * optional string primary_metric = 6;
 * @return {string}
 */
proto.entity.SessionHub.prototype.getPrimaryMetric = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 6, ""));
};


/**
 * @param {string} value
 * @return {!proto.entity.SessionHub} returns this
 */
proto.entity.SessionHub.prototype.setPrimaryMetric = function(value) {
  return jspb.Message.setProto3StringField(this, 6, value);
};


/**
 * optional string individual_metric = 8;
 * @return {string}
 */
proto.entity.SessionHub.prototype.getIndividualMetric = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 8, ""));
};


/**
 * @param {string} value
 * @return {!proto.entity.SessionHub} returns this
 */
proto.entity.SessionHub.prototype.setIndividualMetric = function(value) {
  return jspb.Message.setProto3StringField(this, 8, value);
};


/**
 * repeated string detail_metrics = 7;
 * @return {!Array<string>}
 */
proto.entity.SessionHub.prototype.getDetailMetricsList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 7));
};


/**
 * @param {!Array<string>} value
 * @return {!proto.entity.SessionHub} returns this
 */
proto.entity.SessionHub.prototype.setDetailMetricsList = function(value) {
  return jspb.Message.setField(this, 7, value || []);
};


/**
 * @param {string} value
 * @param {number=} opt_index
 * @return {!proto.entity.SessionHub} returns this
 */
proto.entity.SessionHub.prototype.addDetailMetrics = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 7, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.entity.SessionHub} returns this
 */
proto.entity.SessionHub.prototype.clearDetailMetricsList = function() {
  return this.setDetailMetricsList([]);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.entity.ProductHub.repeatedFields_ = [9,4,7];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.entity.ProductHub.prototype.toObject = function(opt_includeInstance) {
  return proto.entity.ProductHub.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.entity.ProductHub} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.entity.ProductHub.toObject = function(includeInstance, msg) {
  var f, obj = {
    mainDimension: jspb.Message.getFieldWithDefault(msg, 1, ""),
    crossDimension: jspb.Message.getFieldWithDefault(msg, 8, ""),
    detailDimension: jspb.Message.getFieldWithDefault(msg, 2, ""),
    individualDimension: jspb.Message.getFieldWithDefault(msg, 3, ""),
    fixedDimensionsList: jspb.Message.toObjectList(msg.getFixedDimensionsList(),
    proto.entity.FixedDimension.toObject, includeInstance),
    dimensionFilterClausesList: jspb.Message.toObjectList(msg.getDimensionFilterClausesList(),
    proto_common_value_pb.ValueFilterClause.toObject, includeInstance),
    highlightedDetailValue: jspb.Message.getFieldWithDefault(msg, 5, ""),
    primaryMetric: jspb.Message.getFieldWithDefault(msg, 6, ""),
    detailMetricsList: (f = jspb.Message.getRepeatedField(msg, 7)) == null ? undefined : f
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.entity.ProductHub}
 */
proto.entity.ProductHub.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.entity.ProductHub;
  return proto.entity.ProductHub.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.entity.ProductHub} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.entity.ProductHub}
 */
proto.entity.ProductHub.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setMainDimension(value);
      break;
    case 8:
      var value = /** @type {string} */ (reader.readString());
      msg.setCrossDimension(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setDetailDimension(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setIndividualDimension(value);
      break;
    case 9:
      var value = new proto.entity.FixedDimension;
      reader.readMessage(value,proto.entity.FixedDimension.deserializeBinaryFromReader);
      msg.addFixedDimensions(value);
      break;
    case 4:
      var value = new proto_common_value_pb.ValueFilterClause;
      reader.readMessage(value,proto_common_value_pb.ValueFilterClause.deserializeBinaryFromReader);
      msg.addDimensionFilterClauses(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setHighlightedDetailValue(value);
      break;
    case 6:
      var value = /** @type {string} */ (reader.readString());
      msg.setPrimaryMetric(value);
      break;
    case 7:
      var value = /** @type {string} */ (reader.readString());
      msg.addDetailMetrics(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.entity.ProductHub.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.entity.ProductHub.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.entity.ProductHub} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.entity.ProductHub.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getMainDimension();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getCrossDimension();
  if (f.length > 0) {
    writer.writeString(
      8,
      f
    );
  }
  f = message.getDetailDimension();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getIndividualDimension();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getFixedDimensionsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      9,
      f,
      proto.entity.FixedDimension.serializeBinaryToWriter
    );
  }
  f = message.getDimensionFilterClausesList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      4,
      f,
      proto_common_value_pb.ValueFilterClause.serializeBinaryToWriter
    );
  }
  f = message.getHighlightedDetailValue();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
  f = message.getPrimaryMetric();
  if (f.length > 0) {
    writer.writeString(
      6,
      f
    );
  }
  f = message.getDetailMetricsList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      7,
      f
    );
  }
};


/**
 * optional string main_dimension = 1;
 * @return {string}
 */
proto.entity.ProductHub.prototype.getMainDimension = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.entity.ProductHub} returns this
 */
proto.entity.ProductHub.prototype.setMainDimension = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string cross_dimension = 8;
 * @return {string}
 */
proto.entity.ProductHub.prototype.getCrossDimension = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 8, ""));
};


/**
 * @param {string} value
 * @return {!proto.entity.ProductHub} returns this
 */
proto.entity.ProductHub.prototype.setCrossDimension = function(value) {
  return jspb.Message.setProto3StringField(this, 8, value);
};


/**
 * optional string detail_dimension = 2;
 * @return {string}
 */
proto.entity.ProductHub.prototype.getDetailDimension = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.entity.ProductHub} returns this
 */
proto.entity.ProductHub.prototype.setDetailDimension = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string individual_dimension = 3;
 * @return {string}
 */
proto.entity.ProductHub.prototype.getIndividualDimension = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.entity.ProductHub} returns this
 */
proto.entity.ProductHub.prototype.setIndividualDimension = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * repeated FixedDimension fixed_dimensions = 9;
 * @return {!Array<!proto.entity.FixedDimension>}
 */
proto.entity.ProductHub.prototype.getFixedDimensionsList = function() {
  return /** @type{!Array<!proto.entity.FixedDimension>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.entity.FixedDimension, 9));
};


/**
 * @param {!Array<!proto.entity.FixedDimension>} value
 * @return {!proto.entity.ProductHub} returns this
*/
proto.entity.ProductHub.prototype.setFixedDimensionsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 9, value);
};


/**
 * @param {!proto.entity.FixedDimension=} opt_value
 * @param {number=} opt_index
 * @return {!proto.entity.FixedDimension}
 */
proto.entity.ProductHub.prototype.addFixedDimensions = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 9, opt_value, proto.entity.FixedDimension, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.entity.ProductHub} returns this
 */
proto.entity.ProductHub.prototype.clearFixedDimensionsList = function() {
  return this.setFixedDimensionsList([]);
};


/**
 * repeated common.ValueFilterClause dimension_filter_clauses = 4;
 * @return {!Array<!proto.common.ValueFilterClause>}
 */
proto.entity.ProductHub.prototype.getDimensionFilterClausesList = function() {
  return /** @type{!Array<!proto.common.ValueFilterClause>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto_common_value_pb.ValueFilterClause, 4));
};


/**
 * @param {!Array<!proto.common.ValueFilterClause>} value
 * @return {!proto.entity.ProductHub} returns this
*/
proto.entity.ProductHub.prototype.setDimensionFilterClausesList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 4, value);
};


/**
 * @param {!proto.common.ValueFilterClause=} opt_value
 * @param {number=} opt_index
 * @return {!proto.common.ValueFilterClause}
 */
proto.entity.ProductHub.prototype.addDimensionFilterClauses = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 4, opt_value, proto.common.ValueFilterClause, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.entity.ProductHub} returns this
 */
proto.entity.ProductHub.prototype.clearDimensionFilterClausesList = function() {
  return this.setDimensionFilterClausesList([]);
};


/**
 * optional string highlighted_detail_value = 5;
 * @return {string}
 */
proto.entity.ProductHub.prototype.getHighlightedDetailValue = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/**
 * @param {string} value
 * @return {!proto.entity.ProductHub} returns this
 */
proto.entity.ProductHub.prototype.setHighlightedDetailValue = function(value) {
  return jspb.Message.setProto3StringField(this, 5, value);
};


/**
 * optional string primary_metric = 6;
 * @return {string}
 */
proto.entity.ProductHub.prototype.getPrimaryMetric = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 6, ""));
};


/**
 * @param {string} value
 * @return {!proto.entity.ProductHub} returns this
 */
proto.entity.ProductHub.prototype.setPrimaryMetric = function(value) {
  return jspb.Message.setProto3StringField(this, 6, value);
};


/**
 * repeated string detail_metrics = 7;
 * @return {!Array<string>}
 */
proto.entity.ProductHub.prototype.getDetailMetricsList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 7));
};


/**
 * @param {!Array<string>} value
 * @return {!proto.entity.ProductHub} returns this
 */
proto.entity.ProductHub.prototype.setDetailMetricsList = function(value) {
  return jspb.Message.setField(this, 7, value || []);
};


/**
 * @param {string} value
 * @param {number=} opt_index
 * @return {!proto.entity.ProductHub} returns this
 */
proto.entity.ProductHub.prototype.addDetailMetrics = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 7, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.entity.ProductHub} returns this
 */
proto.entity.ProductHub.prototype.clearDetailMetricsList = function() {
  return this.setDetailMetricsList([]);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.entity.TreeNodeHub.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.entity.TreeNodeHub.prototype.toObject = function(opt_includeInstance) {
  return proto.entity.TreeNodeHub.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.entity.TreeNodeHub} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.entity.TreeNodeHub.toObject = function(includeInstance, msg) {
  var f, obj = {
    parentTreeNodeHubAliasesList: (f = jspb.Message.getRepeatedField(msg, 1)) == null ? undefined : f,
    drillDownDimension: jspb.Message.getFieldWithDefault(msg, 2, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.entity.TreeNodeHub}
 */
proto.entity.TreeNodeHub.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.entity.TreeNodeHub;
  return proto.entity.TreeNodeHub.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.entity.TreeNodeHub} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.entity.TreeNodeHub}
 */
proto.entity.TreeNodeHub.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.addParentTreeNodeHubAliases(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setDrillDownDimension(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.entity.TreeNodeHub.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.entity.TreeNodeHub.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.entity.TreeNodeHub} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.entity.TreeNodeHub.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getParentTreeNodeHubAliasesList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      1,
      f
    );
  }
  f = message.getDrillDownDimension();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
};


/**
 * repeated string parent_tree_node_hub_aliases = 1;
 * @return {!Array<string>}
 */
proto.entity.TreeNodeHub.prototype.getParentTreeNodeHubAliasesList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 1));
};


/**
 * @param {!Array<string>} value
 * @return {!proto.entity.TreeNodeHub} returns this
 */
proto.entity.TreeNodeHub.prototype.setParentTreeNodeHubAliasesList = function(value) {
  return jspb.Message.setField(this, 1, value || []);
};


/**
 * @param {string} value
 * @param {number=} opt_index
 * @return {!proto.entity.TreeNodeHub} returns this
 */
proto.entity.TreeNodeHub.prototype.addParentTreeNodeHubAliases = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 1, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.entity.TreeNodeHub} returns this
 */
proto.entity.TreeNodeHub.prototype.clearParentTreeNodeHubAliasesList = function() {
  return this.setParentTreeNodeHubAliasesList([]);
};


/**
 * optional string drill_down_dimension = 2;
 * @return {string}
 */
proto.entity.TreeNodeHub.prototype.getDrillDownDimension = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.entity.TreeNodeHub} returns this
 */
proto.entity.TreeNodeHub.prototype.setDrillDownDimension = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.entity.FixedDimension.prototype.toObject = function(opt_includeInstance) {
  return proto.entity.FixedDimension.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.entity.FixedDimension} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.entity.FixedDimension.toObject = function(includeInstance, msg) {
  var f, obj = {
    dimension: jspb.Message.getFieldWithDefault(msg, 1, ""),
    value: jspb.Message.getFieldWithDefault(msg, 2, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.entity.FixedDimension}
 */
proto.entity.FixedDimension.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.entity.FixedDimension;
  return proto.entity.FixedDimension.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.entity.FixedDimension} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.entity.FixedDimension}
 */
proto.entity.FixedDimension.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setDimension(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setValue(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.entity.FixedDimension.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.entity.FixedDimension.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.entity.FixedDimension} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.entity.FixedDimension.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getDimension();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getValue();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
};


/**
 * optional string dimension = 1;
 * @return {string}
 */
proto.entity.FixedDimension.prototype.getDimension = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.entity.FixedDimension} returns this
 */
proto.entity.FixedDimension.prototype.setDimension = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string value = 2;
 * @return {string}
 */
proto.entity.FixedDimension.prototype.getValue = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.entity.FixedDimension} returns this
 */
proto.entity.FixedDimension.prototype.setValue = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


goog.object.extend(exports, proto.entity);
